import React from 'react';
import styles from '../../styles/SectionOneOne.module.css';

function SectionExplain() {
    
    return (
        <section className={styles.SectionExplain} id="about">
            <div className={styles.InExplain}>
                <div className={styles.ColBack}>
                    <div className={styles.InBack}>
                        <h1>Zdravnik, ki je vedno z vami</h1>
                        <p>Kjerkoli že ste, vedno si lahko zapisujete podatke in kontaktirate zdravnika!</p>
                    </div>
                        <a className={styles.PicButton} href="#try">NAMESTI</a>
                        <a className={styles.PicButtonTwo} href="#try">VEČ INFORMACIJ</a>
                </div>
                <div className={styles.RowImage}>
                    <img className={styles.Image} src={require('../../images/headerimage3.png')} alt="App on mobile phone" />
                </div>
            </div>
        </section>
    )
}
export default SectionExplain;